import { DefinedDefaults } from "@/ui/lib";
import { InputHTMLAttributes } from "react";

/*-------------------------------------
|  Constants
|-------------------------------------*/

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TInputFieldProps = {
  error?: string;
} & InputHTMLAttributes<HTMLInputElement>;

export type TInputType =
  | "button"
  | "checkbox"
  | "color"
  | "date"
  | "datetime-local"
  | "email"
  | "file"
  | "hidden"
  | "image"
  | "month"
  | "number"
  | "radio"
  | "range"
  | "reset"
  | "search"
  | "submit"
  | "tel"
  | "text"
  | "time"
  | "url"
  | "week";

export type TInputProps = {
  label: string;
} & Omit<TInputFieldProps, "type"> & {
  type?: TInputType;
};


type TInputDefaultProps = DefinedDefaults<
  TInputProps,
  "type"
>;


/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const INPUT_DEFAULTS = {
  type: "text",
} satisfies TInputDefaultProps;
